{
  "login": {
    "fractalIdPlaceholder": "Fractal ID ou E-mail",
    "passwordPlaceholder": "Palavra-passe",
    "createFractalIdLink": "Criar Fractal ID",
    "forgotPasswordLink": "Esqueceu-se da palavra-passe?",
    "loginButton": "Iniciar sessão",
    "loginError": "E-mail/Fractal ID ou palavra-passe incorretos"
  },
  "register": {
    "registerTitle": "Registar",
    "namePlaceholder": "Nome completo",
    "emailPlaceholder": "E-mail",
    "passwordPlaceholder": "Palavra-passe",
    "confirmPasswordPlaceholder": "Repita a palavra-passe",
    "registerButton": "Registar",
    "loginLink": "Iniciar sessão com Fractal ID",
    "registerError": "Não foi possível realizar o registo.",
    "emailInUse": "O e-mail inserido já está em uso",
    "emailMessage": "E-mail já registado! Por favor, inicie sessão ou recupere a sua palavra-passe."
  },
  "resetPassword": {
    "resetPasswordTitle": "Recuperar acesso",
    "fractalIdPlaceholder": "Digite seu E-mail",
    "passwordPlaceholder": "Palavra-passe",
    "sendButton": "Enviar",
    "backLink": "Voltar",
    "confirmPasswordPlaceholder": "Confirme a palavra-passe",
    "changeButton": "Alterar palavra-passe",
    "secretQuestion": "Pergunta secreta",
    "passwordResetEmailSentSuccessfully": "Um e-mail de redefinição de palavra-passe foi enviado",
    "passwordResetEmailSentError": "Não foi possível enviar um e-mail de redefinição",
    "noSecretQuestion": "Introduza um email válido",
    "resetPasswordSuccess": "A palavra-passe foi redefinida",
    "resetPasswordError": "Não foi possível redefinir a palavra-passe",
    "alreadyUsedLink": "Este link já foi usado. Solicite um novo link para redefinir a sua palavra-passe."
  },
  "editUserForm": {
    "nameLabel": "Nome",
    "emailLabel": "E-mail",
    "birthdayLabel": "Data de nascimento",
    "phoneLabel": "Telefone",
    "documentLabel": "NIF",
    "genreLabel": "Sexo",
    "maleGenreLabel": "Masculino",
    "femaleGenreLabel": "Feminino",
    "zipcodeLabel": "Código Postal",
    "streetLabel": "Rua",
    "numberLabel": "Número",
    "complementLabel": "Complemento",
    "neighborhoodLabel": "Bairro",
    "cityLabel": "Cidade",
    "stateLabel": "Distrito",
    "phoneMask": "(##) #####-####",
    "selectCountry": "Selecione o seu país",
    "personalInformation": "Informações pessoais:",
    "editDataSuccess": "Dados alterados com sucesso",
    "editDataFailure": "Erro ao alterar dados",
    "updateProfileImage": "Atualizar foto de perfil",
    "removeProfileImage": "Remover foto de perfil",
    "uploadImageError": "Erro ao fazer upload da imagem",
    "uploadImageSizeError": "Insira uma imagem de até 200KB!",
    "removedImage": "Foto de perfil removida",
    "updatedImage": "Foto de perfil alterada",
    "updateImageError": "Erro ao atualizar a foto de perfil"
  },
  "securityCard": {
    "security": "Segurança",
    "securityWarning": "Mantenha os seus dados atualizados para proteger o seu Fractal ID",
    "changePassword": "Alterar palavra-passe",
    "changeEmail": "Alterar e-mail",
    "logoutButton": "Terminar sessão",
    "backButton": "VOLTAR",
    "editEmailSuccess": "E-mail alterado com sucesso",
    "editEmailFailure": "Erro ao alterar o e-mail",
    "editPasswordSuccess": "Palavra-passe alterada com sucesso",
    "editPasswordFailure": "Erro ao alterar a palavra-passe"
  },
  "profilePage": {
    "saveButton": "Guardar",
    "cancelButton": "Cancelar",
    "warning": "Ainda tem alterações pendentes. Deseja mesmo sair?"
  },
  "changeEmailForm": {
    "emailFormTitle": "Alterar E-mail",
    "emailPlaceholder": "E-mail...",
    "changeButton": "Alterar"
  },
  "changePasswordForm": {
    "passwordFormTitle": "Alterar palavra-passe",
    "newPasswordPlaceholder": "Nova palavra-passe",
    "confirmPasswordPlaceholder": "Confirme a nova palavra-passe",
    "changeButton": "Alterar"
  },
  "recoverPasswordForm": {
    "passwordFormTitle": "Redefinição de palavra-passe",
    "newPasswordPlaceholder": "Nova palavra-passe",
    "confirmPasswordPlaceholder": "Confirme a nova palavra-passe",
    "changeButton": "Alterar"
  },
  "changeTemporaryPassword": {
    "passwordFormTitle": "Redefinição de palavra-passe temporária",
    "newPasswordPlaceholder": "Nova palavra-passe",
    "confirmPasswordPlaceholder": "Confirme a nova palavra-passe",
    "changeButton": "Alterar"
  }
}
